Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
Controller = require 'app/scripts/controller'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
{ maybeDisplayOrgMemberLimitsError } = require 'app/scripts/views/organization/member-limits-error'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ isDesktop } = require '@trello/browser'
{ track, trackUe, Noun, Verb } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ allUsersAreAdminsEnabled } = require '@trello/organizations'
$ = require 'jquery'

formatEmailDomain = (emailDomain) ->
  if emailDomain then "(#{emailDomain})" else ''

module.exports = class CreateOrgView extends View
  viewTitleKey: 'create organization'

  initialize: ({ @createOpts, @trackingOpts }) ->
    @trackingOpts ?= { category: null, method: null, context: {} }
    @createOpts ?= {
      isBusinessClass: false
      boardToAddToOrg: false
      isEnterprise: false
    }
    [username, domain] = (Auth.me().get('email') || '').split('@')
    @emailDomain = if domain then domain else ''
    @

  events:
    'click .js-save': 'submit'
    'submit form': 'submit'
    'click .js-business-class': 'clickBusinessClassMore'
    'click .js-enterprise-learn-more': 'clickEnterpriseLearnMore'
    'input .js-display-name': ->
      @updateSubmitButton()

  getValue: (name) -> @$("[name=#{name}]").val()?.trim()

  render: ->
    freeTeamLimitExceeded = featureFlagClient.get('fv.domain-level-free-team-restricted', false)

    if @createOpts.isEnterprise
      templateName = 'org_create_enterprise'
      templateArgs =
        enterprises: Auth.me().enterpriseList
        dontUpsell: isDesktop()
    else
      templateName = 'org_create'
      templateArgs =
        freeTeamLimitExceeded: freeTeamLimitExceeded
        dontUpsell: isDesktop()
        emailDomain: formatEmailDomain(@emailDomain)
        boardToAddToOrg: @createOpts.boardToAddToOrg
        memberCount: @model.memberList?.length
        isPrivateTemplate: @createOpts.isPrivateTemplate

    @$el.html(templates.fill(templateName, templateArgs))
    @updateSubmitButton()

    if freeTeamLimitExceeded
      trackUe(
        category: Noun.BOARD_HEADER,
        verb: Verb.SHOWS,
        directObj: Noun.FREE_TEAM_LIMIT_BLOCKED_POPOVER,
        context:
          domainName: @emailDomain
          context: if isDesktop() then 'desktop' else 'web'
      )

    @

  updateSubmitButton: ->
    @$('.js-save').prop('disabled', @getValue('displayName').length == 0)

  submit: (e) ->
    Util.stop(e)

    if maybeDisplayOrgMemberLimitsError($(e.target), null, Auth.me())
      return

    data = {}

    @$('.js-save')
    .prop('disabled', true)
    .addClass('disabled')

    for name in ['displayName', 'desc', 'enterprise']
      data[name] = @getValue(name)

    if allUsersAreAdminsEnabled()
      data['allAdminsEnabled'] = true

    Auth.me().organizationList.create data, {
      @modelCache
      silent: true
      success: (data) =>
        if @createOpts.boardToAddToOrg
          @createOpts.boardToAddToOrg.update({ idOrganization: data.id })

          if @createOpts.isPrivateTemplate
            @model.setPref('isTemplate', false).save()

        ModelLoader.loadOrganizationMembersMinimal(data.id)
        .then =>
          if @$('.js-add-members').prop('checked')
            org = @model.getOrganization()
            Promise.map @model.memberList.models, (member) ->
              if !org.isMember(member)
                org.changeMemberRole(member, { type: 'normal' })
            , { concurrency: 3 }
        .then =>
          context = if @createOpts.context then @createOpts.context else {}
          enrichedContext = Object.assign(context, { teamId: data.id })
          if @model instanceof Board
            enrichedContext.boardId = @model.get('id')

          if @createOpts.isBusinessClass
            Controller.organizationBillingView(data.get('name'))
            track("New Team", "Create Business Class Team", undefined, data.id)
            trackUe(@trackingOpts.category, 'adds', 'business class team', '', '', @trackingOpts.method, enrichedContext)
          else if @createOpts.isEnterprise
            Controller.organizationAccountView(data.get('name'))
            track("New Team", "Create Enterprise Team", undefined, data.id)
            trackUe(@trackingOpts.category, 'adds', 'enterprise team', '', '', @trackingOpts.method, enrichedContext)
          else
            Controller.organizationBoardsView(data.get('name'))
            track("New Team", "Create Team", undefined, data.id)
            trackUe(@trackingOpts.category, 'adds', 'team', '', '', @trackingOpts.method, enrichedContext)
          PopOver.hide()
          return
        .done()
    }

    return

  clickBusinessClassMore: ->
    track("New Org", "Click Business Class Link")

  clickEnterpriseLearnMore: ->
    trackUe(
      category: Noun.BOARD_HEADER,
      verb: Verb.CLICKS,
      directObj: Noun.FREE_TEAM_LIMIT_BLOCKED_POPOVER_ENTERPRISE_LINK,
      context:
        domainName: @emailDomain
        context: if isDesktop() then 'desktop' else 'web'
    )